import { render, staticRenderFns } from "./StyledTextArea.vue?vue&type=template&id=2e9a1754&scoped=true"
import script from "./StyledTextArea.vue?vue&type=script&lang=js"
export * from "./StyledTextArea.vue?vue&type=script&lang=js"
import style0 from "./StyledTextArea.vue?vue&type=style&index=0&id=2e9a1754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a1754",
  null
  
)

export default component.exports